module.exports = "/_next/static/images/dollar-duotone-4b14b096f67689875d5d3aa381345a0f.svg";